import * as numbers from './numbers/index';

export default {
  numbers
};
